const initialState = {
    userAddress: {}
};

export const miscellaneousReducer = (state = initialState, action={}) => {
    switch (action.type) {
        case 'UPDATE_USER_ADDRESS':
            return {
                ...state,
                userAddress: action.address
            };
        default:
            return state;
    }
}

